import { styled } from '@mui/material/styles';

import { tokens } from '../../../design';

/**
 * Base tile card — mirrors the `.tile` primitive in
 * `design/mockups/admin/dashboard.html`: white surface, 14px radius, the
 * soft double-shadow, 16px padding, flex column. Grid placement
 * (`gridColumn` / `gridRow`) is set per-instance by the parent via `sx`.
 */
export const DashboardTile = styled('div')({
  background: tokens.surface.base,
  borderRadius: 14,
  boxShadow: `0 1px 0 ${tokens.border.default}, 0 8px 16px -12px rgba(12, 20, 15, 0.08)`,
  padding: 16,
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  overflow: 'hidden',
  minWidth: 0,
});
